// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"FormSelect_inputContainer__1QtmB","inputLabel":"FormSelect_inputLabel__2GfAq","inputField":"FormSelect_inputField__3PQgV"};